import { useMutation } from '@tanstack/react-query';
import type { AgentApiCandidateInterviewLogsExtractFromTranscript } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

type Request = {
  candidateProfileId: number;
  transcript: string;
};

export default function useExtractInterviewLogFromTranscript() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: ({ candidateProfileId, transcript }: Request) =>
      fetchJson<AgentApiCandidateInterviewLogsExtractFromTranscript>(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_interview_logs/extract_from_transcript`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ transcript }),
        }
      ),
  });
}
